import mergedPagesData from '../vibesites-pages.json';
import localPagesData from '../pages.json';

type RawPage = Record<string, unknown> & { deleted_at?: string | null };

/** Merged page list (inheritance chain + this site's pages.json) with
    unpublished (`deleted_at`) pages removed. Local overrides are re-applied
    on top because the baked file can lag behind pages.json edits. */
export function getSitePages<T>(): Record<string, T> {
  const baked = mergedPagesData as unknown as Record<string, RawPage>;
  const local = localPagesData as unknown as Record<string, RawPage>;
  const result: Record<string, T> = {};
  for (const alias of new Set([...Object.keys(baked), ...Object.keys(local)])) {
    const page = { ...baked[alias], ...local[alias] };
    if (page.deleted_at) continue;
    result[alias] = page as unknown as T;
  }
  return result;
}
